export const cleanNameUnified = (name: string, back?: string): string => {
  let result = name;

  // Search priority `back` (e.g. 'BG45')
  if (back) {
    const pattern = new RegExp(`${back}\\w*`, 'g');
    result = result.replace(pattern, '');
  } else if (name.includes('BG')) {
    result = result.replace(/[\w]*BG[\w]*/g, '');
  }

  return result
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*\|\s*/g, ' | ')
    .replace(/(\|\s*)+$/, '')
    .trim();
};

export const cleanName = (value: string, back: string): string => {
  if (!back || !value) {
    return value;
  }

  const pattern = new RegExp(`${back}\\w*`, 'g'); // Matches BG45 or BG45WH, etc.
  return value
    .replace(pattern, '')
    .replace(/\s{2,}/g, ' ') // Collapse multiple spaces
    .replace(/\s+$/, '') // Trim trailing spaces
    .trim();
};
